export class DateManager {
  static showOnlyDate(date: string, locale?: string): string {
    locale = locale || 'pt-BR';
    if (date === undefined || date === null) {
      throw new Error('Argument date is required');
    }

    const onlyDate = date.split('T')[0];
    const [year, monthNumber, day] = onlyDate.split('-');
    const formattedMonth = new Intl.DateTimeFormat(locale, {
      month: 'short',
    }).format(new Date(0, parseInt(monthNumber) - 1));

    return `${day} ${formattedMonth.replace('.', '')} ${year}`;
  }
}
